import { call, put, takeEvery } from 'redux-saga/effects'
import { handleApiErrors, handleErrors } from '../../lib/api-errors'
import EnvConfig from '../../config/env'
import axios from 'axios'

import {
  parserToken
} from '../../views/client/actions'

import {
  CLIENT_CHECK_TOKEN,
  CLIENT_CHECK_TOKEN_API,
  CLIENT_CHECK_RIGHT_REQUESTING,
    CLIENT_CHECK_RIGHT_SUCCESS,
  CLIENT_CHECK_RIGHT_ERROR
} from './constants'

let _history = {};

function createClient(){
  let clientApi = axios.create({
    baseURL: EnvConfig.REACT_APP_API_URL,
    headers: {'token': parserToken(localStorage.getItem('token')).Token}
  });
  return clientApi;
}

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { 
      handleErrors(error, _history);
    })
}

function clientRequestApi () {
  const request = createClient().get(CLIENT_CHECK_TOKEN_API)
  return handleRequest(request);
}

function clientCheckRightRequestApi () {
  const request = createClient().get(CLIENT_CHECK_RIGHT_API)
  return handleRequest(request);
}

function* clientRequestFlow (action) {
  try {
    const { history } = action;
    _history = history;

    yield call(clientRequestApi)
  } catch (error) {
  }
}

function* clientCheckRigthRequestFlow (action) {
  try {
    let result = yield call(clientCheckRightRequestApi)
    
    yield put({ type: CLIENT_CHECK_RIGHT_SUCCESS, data: result.is_admin })
  } catch (error) {
    yield put({ type: CLIENT_CHECK_RIGHT_ERROR, error: error })
  }
}

function* clientRequestWatcher () {
  yield takeEvery(CLIENT_CHECK_TOKEN, clientRequestFlow)
  yield takeEvery(CLIENT_CHECK_RIGHT_REQUESTING, clientCheckRigthRequestFlow)
}

export default clientRequestWatcher



// WEBPACK FOOTER //
// ./src/views/client/sagas.js